export const INITIAL_VALUES = {
  name: '',
  category_id: null,
  package_id: null,
  'group.id': null,
  // transfer_group: false,
};
